var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampanaNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12968",
    "data-name": "Group 12968",
    transform: "translate(-98 -160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(98 160)",
    fill: "#394f65"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12967",
    "data-name": "Group 12967",
    transform: "translate(469.297 844.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    d: "M-352.457-668.185c-.209-.173-.389-.332-.579-.477a3.894,3.894,0,0,1-1.525-2.746c-.083-.7-.12-1.414-.146-2.123a7.5,7.5,0,0,0-.321-2.2,3.766,3.766,0,0,0-3.115-2.62l-.049-.011c-.167-.609-.437-.848-.916-.814a.81.81,0,0,0-.77.8c-.263.069-.533.123-.79.211a3.741,3.741,0,0,0-2.494,2.811,8.949,8.949,0,0,0-.208,1.857c-.032.726-.071,1.453-.16,2.173a3.994,3.994,0,0,1-1.683,2.805c-.133.1-.257.21-.411.337Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    d: "M-225.133-337.944a1.762,1.762,0,0,0,1.864,1.469,1.736,1.736,0,0,0,1.654-1.469Z",
    transform: "translate(-135.674 -329.5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanaNotification);
export default __webpack_public_path__ + "static/media/campana_notification.6bf95f21f19824b709d917a425793a72.svg";
export { ForwardRef as ReactComponent };